exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fuller[data-v-207d7fcc]{height:calc(100% - 5rem)}@media (min-width:768px){.w-fuller[data-v-207d7fcc]{width:calc(100% - 28rem)}}@media (min-width:1280px){.w-fuller[data-v-207d7fcc]{width:calc(100% - 32rem)}}", ""]);

// exports
